/* eslint-disable no-case-declarations */
import {
  validateLotCatalog,
  validateRealizedPrice
} from './EditLotValidation';

const validateLotCatalogForm = (
  fieldName,
  lotData,
  lotNumberArray,
  validation,
  lots
) => {
  switch (fieldName) {
    // These two need to be tested together
    case 'lotNumber':
    case 'lotExt':
      const { lotNumber, lotExt } = validateLotCatalog(
        lotData.lotNumber,
        lotData.lotExt,
        lotNumberArray,
        lots
      );
      validation.lotNumber = lotNumber;
      validation.lotExt = lotExt;
      break;
    case 'realizedPrice':
      validation.realizedPrice = validateRealizedPrice(lotData.realizedPrice);
      break;
    default:
      return validation;
  }

  return validation;
};

export default validateLotCatalogForm;
